import { Home, Users, MessageCircle, User, Settings } from 'lucide-react';

export const MAIN_NAV_ITEMS = [
  { path: '/discover', labelKey: 'nav.explore', icon: Home },
  { path: '/network', labelKey: 'nav.network', icon: Users },
  { path: '/chat', labelKey: 'nav.chat', icon: MessageCircle },
  { path: '/profile', labelKey: 'nav.profile', icon: User },
  { path: '/settings', labelKey: 'nav.settings', icon: Settings },
] as const;

export type MainNavLabelKey = (typeof MAIN_NAV_ITEMS)[number]['labelKey'];
